// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__FPAvg","errorLogs":"styles_errorLogs__3kAvA"};